import React from "react";
import VideoAudio from "./VideoAudio/VideoAudio";
import { useSelector } from "react-redux";
import MediaInfo from "./MediaInfo/MediaInfo";
import {
  selectMembersMuted,
  PINNED_CAMERA,
  PINNED_SHARE,
  enlargeScreen,
  enlargeCamera,
} from "slices/spaceMediaSlice";
import VideoBarPersonMutedForMe from "graphics/icons/SideVideo/VideoBarPersonMutedForMe";
import VideoBarPersonUnMutedForMe from "graphics/icons/SideVideo/VideoBarPersonUnMutedForMe";
import { muteForMe, unmuteForMe } from "slices/spaceSlice";
import CamOn from "graphics/icons/MediaControls/Cam/CamOn";
import Avatar from "components/Home/ui/Avatar";
import ShareOn from "graphics/icons/MediaControls/Share/ShareOn";

const MediaSquare = ({ luid, visual }) => {
  // window.efs_debug && window.log("MEDIA SQUARE RENDERED");
  const person = useSelector((state) => state.spaceMedia.people[luid]);
  const {
    micOn,
    camOn,
    share,
    shout,
    pinnedShare,
    mutedForMe,
    avatar_key,
    given_name,
    family_name,
    inRange,
  } = person;
  const membersMuted = useSelector(selectMembersMuted);

  return (
    <>
      <div
        className={`side-video-rollover ${
          shout || pinnedShare ? "rollover-shouting" : ""
        } ${
          share === "board" && visual === PINNED_SHARE ? "whiteboarder" : ""
        }`}
      >
        {visual !== PINNED_SHARE &&
        visual !== PINNED_CAMERA &&
        (camOn || share) ? (
          <div className="expanders">
            {share ? (
              <button
                onClick={() => {
                  enlargeScreen(luid);
                }}
              >
                <ShareOn />
                {/* <ExpandScreen /> */}
                {/* Expand */}
              </button>
            ) : null}
            {camOn && !(shout === "share" && !inRange) ? (
              <button
                onClick={() => {
                  enlargeCamera(luid);
                }}
              >
                <CamOn />
                {/* <ExpandCamera /> */}
                {/* Expand */}
              </button>
            ) : null}
          </div>
        ) : (
          <div className="expanders go-through "></div>
        )}
        <div className="default-options">
          <div className="name">
            <div>{given_name}</div>
            <div>{family_name}</div>
          </div>
          <button
            className="muting"
            onClick={() => (mutedForMe ? unmuteForMe(luid) : muteForMe(luid))}
          >
            <div className="words">
              {mutedForMe ? "Unmute For Me" : "Mute For Me"}
            </div>
            <span>
              {mutedForMe ? (
                <VideoBarPersonMutedForMe />
              ) : (
                <VideoBarPersonUnMutedForMe />
              )}
            </span>
          </button>
          <div className="video-bar-avatar">
            <Avatar
              avatar_key={avatar_key}
              given_name={given_name}
              family_name={family_name}
            />
          </div>
        </div>
      </div>

      <div className={`remote-side-video ${visual}`}>
        <div
          className={`shouter ${
            shout || pinnedShare ? "remote-shouting" : ""
          } ${!camOn && !share ? "no-video" : ""}`}
        ></div>
        {(camOn || share || micOn) && <VideoAudio person={person} />}
      </div>

      <MediaInfo
        luid={luid}
        person={person}
        visual={visual}
        membersMuted={membersMuted}
      />
    </>
  );
};
export default MediaSquare;
